"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var common_hooks_1 = require("@l2p/common-hooks");
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var ButtonWithTimer = function (_a) {
    var onButtonClick = _a.onButtonClick, text = _a.text, endDate = _a.endDate;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var time = (0, common_hooks_1.useTimer)({ endDate: endDate }).time;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.participateContainer },
        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "300px", maxWidth: "100%", className: "participate", height: breakpoints.mobile ? '32px' : '48px', onClick: onButtonClick },
            text,
            react_1.default.createElement("section", null,
                react_1.default.createElement("span", null, t('timeLeft')),
                " ",
                time.days,
                ":",
                time.hours,
                ":",
                time.minutes,
                ":",
                time.seconds))));
};
exports.default = ButtonWithTimer;
